import React from 'react';
import { Helmet } from 'react-helmet-async';
// ✅ Helmet for SEO
import OrderTracking from '../elementsui/OrderTracking';

const OrderTrackingPage = () => {
  return (
    <div>
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Track Your Order | binzal - Live Delivery Updates</title>
        <meta name="description" content="Track your binzal grocery order in real time. Get live updates from dispatch to doorstep across Bihar." />
        <meta name="keywords" content="track order binzal, grocery delivery tracking, order status Bihar, live order location" />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Track Order | binzal" />
        <meta property="og:description" content="Live order tracking for binzal grocery deliveries across Bihar. Know exactly where your order is." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <OrderTracking />
    </div>
  );
};

export default OrderTrackingPage;
